import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export function formatDateRome(
  date: string | Date,
  format = "DD/MM/YYYY HH:mm",
): string {
  return dayjs(date).tz("Europe/Rome").format(format);
}
